import slugify from 'slugify'

import { PartialUser } from 'types/user'

const slugifyOptions = {
  replacement: '_',
  remove: /[*+~.()'"!:@]/g,
  lower: true,
  strict: true,
  trim: true,
}

export const toSlug = (string: string, options = {}) => {
  if (!string) return ''

  return slugify(string, { ...slugifyOptions, ...options })
}

export const removeNonDigits = (value: string) => value.replace(/\D/g, '')

export const formatPhoneNumber = (phoneNumberString: string) => {
  if (!phoneNumberString) return ''

  const formattedPhoneNumber = phoneNumberString.substring(0, 14).replace(/\D/g, '')
  const cleaned = `${formattedPhoneNumber}`.replace(/\D/g, '')
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`
  }

  return formattedPhoneNumber
}

export const formatPrice = (priceInCents: string) => {
  const cleanedPrice = removeNonDigits(priceInCents) || '0'
  const value = parseInt(cleanedPrice, 10)
  const dollars = Math.floor(value / 100)
  const cents = Math.floor((value % 100) * 100) / 100
  return `$${dollars}.${cents.toString().padStart(2, '0')}`
}

export const generateRoomName = (users: PartialUser[]) =>
  users
    .map((user) => user.firstName)
    .sort()
    .join(' & ')

const checkUserHasId = (user: PartialUser): user is PartialUser & { id: string } => !!user.id

export const generateReferenceIds = (users: PartialUser[]): string[] => {
  const usersWithIds = users.filter(checkUserHasId)

  return usersWithIds.map((user) => user.id).sort()
}

export const capitalize = (string: string) => {
  if (!string) return ''

  return string.charAt(0).toUpperCase() + string.slice(1)
}
